import React from 'react';
import { ROOM_STATUS_LABELS, RoomStatusFilter } from '../../../types/portvilleRoom';

interface StatusFilterProps {
  currentFilter: RoomStatusFilter;
  onFilterChange: (filter: RoomStatusFilter) => void;
  roomCounts: {
    all: number;
    occupied: number;
    preparing: number;
    vacant: number;
    contracting: number;
    facility: number;
    moveoutPending: number;
    contractCancellationPending: number;
    extensionPending: number;
  };
}

const StatusFilter: React.FC<StatusFilterProps> = ({ 
  currentFilter, 
  onFilterChange, 
  roomCounts 
}) => {
  const filterOptions = [
    { value: 'all' as const, label: '전체', count: roomCounts.all },
    { value: 'occupied' as const, label: ROOM_STATUS_LABELS.occupied, count: roomCounts.occupied },
    { value: 'preparing' as const, label: ROOM_STATUS_LABELS.preparing, count: roomCounts.preparing },
    { value: 'vacant' as const, label: ROOM_STATUS_LABELS.vacant, count: roomCounts.vacant },
    { value: 'contracting' as const, label: ROOM_STATUS_LABELS.contracting, count: roomCounts.contracting },
    { value: 'facility' as const, label: ROOM_STATUS_LABELS.facility, count: roomCounts.facility },
    { value: 'moveout-pending' as const, label: '퇴거신청', count: roomCounts.moveoutPending },
    { value: 'contract-cancellation-pending' as const, label: '포기신청', count: roomCounts.contractCancellationPending },
    { value: 'extension-pending' as const, label: '연장신청', count: roomCounts.extensionPending },
  ];

  const getButtonStyle = (filterValue: string) => {
    const isActive = currentFilter === filterValue;
    const baseStyle = "px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 border";
    
    if (isActive) {
      if (filterValue === 'all') {
        return `${baseStyle} bg-blue-600 text-white border-blue-600`;
      } else if (filterValue === 'occupied') {
        return `${baseStyle} bg-red-600 text-white border-red-600`;
      } else if (filterValue === 'preparing') {
        return `${baseStyle} bg-yellow-600 text-white border-yellow-600`;
      } else if (filterValue === 'vacant') {
        return `${baseStyle} bg-green-600 text-white border-green-600`;
      } else if (filterValue === 'contracting') {
        return `${baseStyle} bg-blue-500 text-white border-blue-500`;
      } else if (filterValue === 'moveout-pending') {
        return `${baseStyle} bg-red-500 text-white border-red-500`;
      } else if (filterValue === 'contract-cancellation-pending') {
        return `${baseStyle} bg-red-700 text-white border-red-700`;
      } else if (filterValue === 'extension-pending') {
        return `${baseStyle} bg-orange-600 text-white border-orange-600`;
      } else if (filterValue === 'facility') {
        return `${baseStyle} bg-purple-600 text-white border-purple-600`;
      }
    }
    
    return `${baseStyle} bg-white text-gray-700 border-gray-300 hover:bg-gray-50`;
  };

  return (
    <div className="mb-6">
      <div className="flex flex-wrap gap-2">
        {filterOptions.map((option) => (
          <button
            key={option.value}
            onClick={() => onFilterChange(option.value)}
            className={getButtonStyle(option.value)}
          >
            {option.label} ({option.count})
          </button>
        ))}
      </div>
    </div>
  );
};

export default StatusFilter; 
